export default __webpack_public_path__ + "static/media/Logo.7efd9d40.svg";